import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
    DEFAULT_ORIGINAL_LANGUAGE_KEY,
    GENRE_LIST,
    TARGET_LANGUAGE_LIST,
    RATIO_LIST,
    DURATION_LIST,
} from '@src/config/FJVideoSettingDataConfig';
import FJSubtitleStyleList from '@src/config/FJSubtitleStyleList';
/** 生成流程「参数设置」面板：显隐 + 与 `FJGeneratingSettingsPanel` 绑定的表单字段 */
export type SettingPageState = {
    /** 原音语言，对应 `ORIGINAL_LANGUAGE_LIST[].value` */
    originalLanguageKey: string;
    /** 文案语言，对应 `TARGET_LANGUAGE_LIST[].value` */
    textLanguageKey: string;
    /** 剪辑目标，对应 `GENRE_LIST[].value` */
    genreKey: string;
    /** 片段时长类型，对应 `DURATION_LIST[].value` */
    clipLengthKey: string;
    /** 画幅比例，对应 `RATIO_LIST` 中的字符串项（与展示相同） */
    aspectRatioKey: string;
    /** 对应 `FJSubtitleStyleList` 项 id */
    subtitleStyleId: string;
    /** 抓取高光提示词 */
    captureKeyMoments: string;
};

const initialState: SettingPageState = {
    originalLanguageKey: DEFAULT_ORIGINAL_LANGUAGE_KEY,
    textLanguageKey: TARGET_LANGUAGE_LIST[0].value,
    genreKey: GENRE_LIST[0].value,
    clipLengthKey: DURATION_LIST[0].value,
    aspectRatioKey: RATIO_LIST[0],
    subtitleStyleId: FJSubtitleStyleList[2].id,
    captureKeyMoments: '',
};

const fjSettingPageSlice = createSlice({
    name: 'settingPage',
    initialState,
    reducers: {
        resetSettingPage: state => {
            state.originalLanguageKey = initialState.originalLanguageKey;
            state.textLanguageKey = initialState.textLanguageKey;
            state.genreKey = initialState.genreKey;
            state.clipLengthKey = initialState.clipLengthKey;
            state.aspectRatioKey = initialState.aspectRatioKey;
            state.subtitleStyleId = initialState.subtitleStyleId;
            state.captureKeyMoments = initialState.captureKeyMoments;
        },
        setOriginalLanguageKey: (state, action: PayloadAction<string>) => {
            state.originalLanguageKey = action.payload;
        },
        setTextLanguageKey: (state, action: PayloadAction<string>) => {
            state.textLanguageKey = action.payload;
        },
        setGenreKey: (state, action: PayloadAction<string>) => {
            state.genreKey = action.payload;
        },
        setClipLengthKey: (state, action: PayloadAction<string>) => {
            state.clipLengthKey = action.payload;
        },
        setAspectRatioKey: (state, action: PayloadAction<string>) => {
            state.aspectRatioKey = action.payload;
        },
        setSubtitleStyleId: (state, action: PayloadAction<string>) => {
            state.subtitleStyleId = action.payload;
        },
        setCaptureKeyMoments: (state, action: PayloadAction<string>) => {
            state.captureKeyMoments = action.payload;
        },
    },
});

export const {
    resetSettingPage,
    setOriginalLanguageKey,
    setTextLanguageKey,
    setGenreKey,
    setClipLengthKey,
    setAspectRatioKey,
    setSubtitleStyleId,
    setCaptureKeyMoments,
} = fjSettingPageSlice.actions;

export default fjSettingPageSlice.reducer;
